export default __webpack_public_path__ + "static/media/split_3.babf4fcb.svg";